// src/components/UserMenu.jsx
import React, { useRef } from 'react';
import { useAuthSession } from './AuthSessionContext';
import { deepPurple } from '@mui/material/colors';
import LogoutIcon from '@mui/icons-material/Logout';
import { Avatar, Menu, MenuItem, IconButton, Typography, Divider } from '@mui/material';


const UserMenu = ({ userEmail }) => {
  const { logout } = useAuthSession();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const iconButtonRef = useRef(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    if (iconButtonRef.current) {
        iconButtonRef.current.blur();
    }
  };

  const handleLogout = async () => {
    handleMenuClose();
    logout();
  };


  // Function to generate initials from email
  const getInitials = (email) => {
    const name = email?.split('@')[0];
    const names = name?.split('.');
    const initials = names?.map((n) => n.charAt(0).toUpperCase()).join('');
    return initials;
  };

  return (
    <div>
      
        <Avatar
            onClick={handleMenuOpen}
            sx={{ bgcolor: deepPurple[500], width: 32, height: 32 }}
        >
            {getInitials(userEmail)}
        </Avatar>
        

        <Menu
        anchorEl={anchorEl}
        id="user-menu"
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
        PaperProps={{
            elevation: 3,
            sx: {
                mt: 1.5,
                minWidth: 150,
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <MenuItem disabled>
                <Typography variant="subtitle1">{userEmail}</Typography>
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
                <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                Logout
            </MenuItem>
        </Menu>
    </div>
  );
};

export default UserMenu;
